<template>
  <DashboardPage>
    <SelectionSiteForm :id="route.params.id" />
  </DashboardPage>
</template>
  
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import SelectionSiteForm from './components/SelectionSiteForm.vue'

const route = useRoute()

</script>